<ul id="{{ 'ul' + fieldKey }}" class="bulkList" style="margin-bottom: 0px !important;">
    <li id="{{ 'li' + item.key }}" *ngFor="let item of listOptions">
        <span (click)="onClick(item)">
            <i aria-hidden="true" class="" [ngClass]="item.iconClass"></i>
            {{ item.value | translate }}
        </span>
    </li>
</ul>